import React, { useRef } from 'react';
import {
    Button, Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { isFileExtValid } from '../../helpers/common';

function ClaimDocumentUploadCommonModal({ lorCount, openModal, handleClose, importLabel = "Documents Upload", existingFiles = [{
    file: null,
    description: "",
}], upload, activeTab, isLoading }) {

    const fileRef = useRef([]);

    const initialValues = {
        files: [
            ...existingFiles
        ],
    };

    // Validation Schema
    const validationSchema = Yup.object().shape({
        files: Yup.array()
            .of(
                Yup.object().shape({
                    file: Yup.mixed()
                        .required("File is required"),
                    // description: Yup.string()
                    //     .required("Description is required")
                    //     .min(3, "Description must be at least 3 characters long"),
                })
            )
        // .min(1, "At least one file is required"),
    });

    // On Submit
    const onSubmit = (values) => {
        upload(values);
    };

    // Add New File-Description Pair
    const addFileField = (setFieldValue, values) => {
        const newFiles = [...values.files, { file: null, description: "" }];
        setFieldValue("files", newFiles);
    };

    const uploadFiles = async (file, setFieldValue, index) => {
        fileRef.current.push(React.createRef());
        const fileName = file?.name;
        const fileSize = file?.size;
        const fileExt = file?.type;


        if (file && fileName && fileSize) {
            const maxFileSize = process.env.REACT_APP_FILE_SIZE * Math.pow(10, 6);

            if (fileSize > maxFileSize) {
                clearFileInput(index, setFieldValue)
                toast.error(`File size should not be more than ${process.env.REACT_APP_FILE_SIZE} MB`)
            } else if (!isFileExtValid(fileExt, fileName)) {
                toast.error('Invalid file name or multiple extensions detected')

            }
            else {
                setFieldValue(
                    `files[${index}].file`, file);
            }
        }
        else {
            clearFileInput(index, setFieldValue)
        }
    }

    const clearFileInput = (index, setFieldValue) => {
        setFieldValue(`files[${index}].file`, null)
        const input = fileRef.current[index]?.current;
        if (input) {
            input.value = "";
        }
    }

    // Remove File-Description Pair
    const removeFileField = (index, setFieldValue, values) => {
        let newFiles = [];
        if (values.files[index].id)
            newFiles = values.files.map((file, i) => i === index ? { ...file, isDeleted: true } : file);
        else
            newFiles = values.files.filter((_, i) => i !== index);
        setFieldValue("files", newFiles);
    };

    return (
        <Modal isOpen={openModal} toggle={() => handleClose('ADD')} size='lg'>
            <ModalHeader toggle={() => handleClose('ADD')}>{importLabel} Upload</ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values, setFieldValue, errors, touched, setFieldTouched, dirty }) => (
                            <Form>
                                {values.files.map((fileObj, index) => (
                                    !fileObj.isDeleted && <div key={index} className="d-flex mb-2">
                                        <div className='me-3' style={{ width: "100%" }}>
                                            <label htmlFor={`files[${index}].file`}>File</label>
                                            {fileObj.id ? <div style={{ pointer: "cursor", fontWeight: 600 }}>{fileObj?.file}</div>
                                                :
                                                <>
                                                    <input
                                                        type="file"
                                                        id={`files[${index}].file`}
                                                        name={`files[${index}].file`}
                                                        className={`form-control file-input ${touched?.files?.length > 0 && touched.files[index]?.file && errors?.files?.length > 0 && errors?.files[index]?.file ? 'is-invalid' : ''}`}
                                                        onChange={(event) => {
                                                            uploadFiles(event.currentTarget.files[0], setFieldValue, index);
                                                        }}
                                                        onBlur={() => setFieldTouched(`files[${index}].file`, true)}
                                                        ref={fileRef[index]}
                                                    />
                                                    <ErrorMessage
                                                        name={`files[${index}].file`}
                                                        component="div"
                                                        style={{ color: "red" }}
                                                    />
                                                </>}

                                        </div>
                                        <div style={index == 0 ? { width: "100%" } : { width: "95%" }}>
                                            <label htmlFor={`files[${index}].description`}>
                                                Description
                                            </label>
                                            <Field
                                                type="text"
                                                id={`files[${index}].description`}
                                                name={`files[${index}].description`}
                                                placeholder="Enter description"
                                                style={{ display: "block" }}
                                                className={`form-control ${touched?.files?.length > 0 && touched.files[index]?.description && errors?.files?.length > 0 && errors?.files[index]?.description ? 'is-invalid' : ''}`}
                                                disabled={fileObj.id}
                                            />
                                            <ErrorMessage
                                                name={`files[${index}].description`}
                                                component="div"
                                                style={{ color: "red" }}
                                            />
                                        </div>

                                        {!(!fileObj?.id && values.files.filter(file => !file.id).length === 1) && <Button
                                            type="button"
                                            color="link"
                                            className="fw-normal text-danger p-0"
                                            onClick={() => removeFileField(index, setFieldValue, values)}
                                            style={{ width: "5%" }}
                                            disabled={
                                                !fileObj?.id && values.files.filter(file => !file.id).length === 1
                                            }

                                        >
                                            <i className="bx bx-trash" style={{ width: '24px' }}></i>
                                        </Button>}
                                    </div>
                                ))}
                                <Button
                                    type="button"
                                    color="link mt-2"
                                    style={{ textDecoration: 'none' }}
                                    className="text-success p-0 mb-3"
                                    onClick={() => addFileField(setFieldValue, values)}

                                >
                                    <span>Add More +</span>
                                </Button>
                                <ModalFooter className='d-flex justify-content-between'>
                                    <Button color="primary" type="submit" className="ITC_Blue_color" disabled={!dirty || isLoading}>
                                        {lorCount === 0 && activeTab === 'JIR_DOCUMENTS' ? 'Add JIR & LOR' : 'Submit'}
                                    </Button>
                                </ModalFooter>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ModalBody>
        </Modal >
    );

}

export default ClaimDocumentUploadCommonModal;